import { render, staticRenderFns } from "./lWaterElectricity.vue?vue&type=template&id=c8dfc64a&scoped=true&"
import script from "./lWaterElectricity.vue?vue&type=script&lang=js&"
export * from "./lWaterElectricity.vue?vue&type=script&lang=js&"
import style0 from "./lWaterElectricity.vue?vue&type=style&index=0&id=c8dfc64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dfc64a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
